// Slice names — single source of truth for all Redux slices
export const REGISTRATION_SLICE = 'registration'
export const AUTH_API_SLICE = 'authApi'
export const COVERAGE_TYPE_API_SLICE = 'coverageTypeApi'
export const PLAN_API_SLICE = 'planApi'
export const INSURANCE_PRODUCT_API_SLICE = 'insuranceProductApi'
export const VEHICLE_DETAILS_API_SLICE = 'vehicleDetailsSearchApi'
export const ENUMS_API_SLICE = 'enumsApi'
export const INSURANCE_CATEGORY_SLICE = 'insuranceCategory'
